export default "__VITE_ASSET__B1hwurT0__"